module.exports = __webpack_public_path__ + "static/media/dre3.png.87a83d16.jpg";